document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initFaq();
  initContador();
  initAnimacionEscena();
});

function initAnimacionEscena() {
  document.querySelectorAll('[data-sv-anim]').forEach(function (escena) {
    var slides = escena.querySelectorAll('.sv-anim-slide');
    if (slides.length < 2) return;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;
    var indice = 0;
    setInterval(function () {
      slides[indice].classList.remove('sv-anim-slide--activa');
      indice = (indice + 1) % slides.length;
      slides[indice].classList.add('sv-anim-slide--activa');
    }, 5500);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.sv-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('sv-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.dataset.svDelay || 0;
        setTimeout(function () { entry.target.classList.add('sv-visible'); }, delay);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-sv-comparador]').forEach(function (wrap) {
    var handle = wrap.querySelector('[data-sv-handle]');
    var after = wrap.querySelector('[data-sv-after]');
    if (!handle || !after) return;

    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    // Se puede arrastrar tocando en cualquier parte de la imagen, no solo el
    // círculo: en el celular es muy difícil acertarle a un círculo chico.
    wrap.addEventListener('pointerdown', function (e) {
      dragging = true;
      wrap.setPointerCapture(e.pointerId);
      setPos(e.clientX);
    });
    wrap.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('pointercancel', function () { dragging = false; });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') { current = Math.max(0, current - 5); }
      if (e.key === 'ArrowRight') { current = Math.min(100, current + 5); }
      after.style.clipPath = 'inset(0 ' + (100 - current) + '% 0 0)';
      handle.style.left = current + '%';
    });
  });
}

function initFaq() {
  document.querySelectorAll('[data-sv-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-sv-faq-btn]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = item.classList.contains('sv-faq-abierto');
      item.closest('[data-sv-faq]').querySelectorAll('[data-sv-faq-item]').forEach(function (i) {
        i.classList.remove('sv-faq-abierto');
        i.querySelector('[data-sv-faq-btn]').setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('sv-faq-abierto');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initContador() {
  var els = document.querySelectorAll('[data-sv-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.dataset.svContador) || 0;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString('es-PY');
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}
